module.exports = __webpack_public_path__ + "static/media/btn_owl_active.f88fd961.png";